export default __webpack_public_path__ + "static/media/Town view from top.ac5e208e.jpg";